"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ResponseBase = /** @class */ (function () {
    function ResponseBase() {
        this.status = "not_sent";
        this.code = "";
        this.message = "";
        this.supportCode = "";
        this.details = new Array();
    }
    return ResponseBase;
}());
exports.ResponseBase = ResponseBase;
